import { createBrowserRouter } from 'react-router-dom';
import RouteError from '/@/components/route-error';
import App from '/@/views/app';

export const createRouter = () => {
    return createBrowserRouter([
        {
            path: '*',
            element: <App />,
            errorElement: <RouteError />,
        },
    ]);
};
